import { render, staticRenderFns } from "./lowPowe.vue?vue&type=template&id=55edcd79&scoped=true"
import script from "./lowPowe.vue?vue&type=script&lang=js"
export * from "./lowPowe.vue?vue&type=script&lang=js"
import style0 from "./lowPowe.vue?vue&type=style&index=0&id=55edcd79&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edcd79",
  null
  
)

export default component.exports